<!--
 * @Author: your name
 * @Date: 2020-09-14 10:02:55
 * @LastEditTime: 2020-09-14 10:55:15
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \jiachi-wap\src\components\HelloWorld.vue
-->
<template>
<div class="nav">
    <img src="../assets/img/option.png" alt srcset @click="show=true" />
    <img src="../assets/img/search.png" alt srcset @click="$router.push({path:'/search'})" />
    <div class="mask" v-show="show" @click="show=false"></div>
    <ul class="bar" :class="{active:show}">
        <router-link tag="li" v-for="(item, index) in route" :key="index" :to="{path:item.path}" :class="{active:$route.meta.id == item.meta.id}">{{item.name}}</router-link>
    </ul>
</div>
</template>

<script>
export default {
    name: "HelloWorld",
    props: {
        msg: String,
    },
    data() {
        return {
            show: false,
        };
    },
    computed: {
        route() {
            return this.$router.options.routes.filter((val) => {
                return !val.meta.hidden;
            });
        },
    },
    watch: {
        "$route.path": {
            handler() {
                this.show = false;
            },
            deep: true,
        },
    },
    created() {
        console.log(this.$router);
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less" scoped>
.nav {
    width: 100%;
    height: 0.86rem;
    background: rgba(255, 255, 255, 0.4);
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    padding: 0 0.3rem;
    box-sizing: border-box;
}

.nav img:active {
    opacity: 0.78;
}

.nav img:first-child {
    height: 0.4rem;
}

.nav img:last-child {
    width: 0.22rem;
}

.bar {
    width: 50vw;
    height: 100vh;
    top: 0;
    position: fixed;
    left: 0;
    z-index: 1;
    background: #0a66c0;
    padding-top: 0.47rem;
    box-sizing: border-box;
    transition: all 0.15s linear;
    transform: translateX(-100%);

    li {
        line-height: 1.3rem;
        text-align: center;
        font-size: 0.29rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: white;
    }

    li.active {
        background: white;
        color: #073496;
        font-weight: bold;
    }
}

.bar.active {
    transform: translateX(0);
}

.mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    top: 0;
    height: 100vh;
    background: rgba(0, 0, 0, 0.4);
    z-index: 1;
}
</style>
